import React from 'react'
import PropTypes from 'prop-types'

import { map, split, join, upperFirst, camelCase, values, has } from 'lodash'

import * as MaterialIcons from 'react-icons/lib/md'
import * as FontAwesome from 'react-icons/lib/fa'

import classes from 'classnames'

import { ui } from '../redux'

import './Icon.css'

const ICONS = {
    Md : MaterialIcons,
    Fa : FontAwesome
}

const Icon = ({ name, className, intent, ...otherProps }) => {
    const [pack, iconName] = map(split(name, '/'), (name) => upperFirst(camelCase(name)))

    const fullIconName = join([pack, iconName], '')

    if (!has(ICONS[pack], fullIconName)) {
        return null
    }

    return React.createElement(ICONS[pack][fullIconName], {
        className: classes(className, `icon-${intent}`),
        ...otherProps
    })
}

Icon.propTypes = {
    name   : PropTypes.string.isRequired,
    intent : PropTypes.oneOf(values(ui.INTENT))
}

export default Icon
